<script setup>
import i18n from "@/i18n";
import { EventManager, Events } from "@events";
import { computed, ref } from "vue";
const showMessage = ref(false);
const message = ref("");

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const eventEmitter = EventManager.getEventEmitter(props.rtcId);
const emit = defineEmits(["setPanelState"]);

eventEmitter.on(Events.RecordingFailed, (payload) => {
  message.value = payload.message;
  showMessage.value = true;
  emit("setPanelState", true);
});

eventEmitter.on(Events.RecordingStarted, () => {
  showMessage.value = false;
  message.value = "";
  emit("setPanelState", false);
});

const alertContent = computed(() => {
  let result = i18n.global.t("RecordingFailed");
  if (message.value) {
    result += " " + i18n.global.t("RecordingFailedReason", { reason: message.value });
  }
  return result;
});
</script>

<template>
  <v-alert v-if="showMessage" density="compact" :text="alertContent" :title="i18n.global.t('Error')" type="error"></v-alert>
</template>
